import { ColumnDef } from '@tanstack/react-table'
import { IRefuelling } from '../models/models'
import dateFormat from 'dateformat'
import Status from '../components/UI/Status'

export const refuellingsColumns: ColumnDef<IRefuelling>[] = [
	{
		accessorKey: 'id',
		header: 'Номер переміщення',
	},
	{
		accessorKey: 'exciseInvoiceNumber',
		header: '№ акцизної накладної',
		enableSorting: false,
	},
	{
		accessorKey: 'status',
		header: 'Статус',
		cell: (value) => <Status type={value.getValue<any>()} />,
	},
	{
		accessorKey: 'date',
		header: 'Дата/Час створення',
		cell: (value) => (
			<>
				{dateFormat(value.row.original.date, 'dd.mm.yyyy')} <br />
				{dateFormat(value.row.original.date, 'HH:MM')}
			</>
		),
	},
	{
		accessorKey: 'refueller',
		header: 'Звідки заправка',
		enableSorting: false,
		cell: (value) => (
			<>
				{value.row.original.refueller.type} <br />
				{value.row.original.refueller.name}
			</>
		),
	},
	{
		accessorKey: 'filledTank',
		header: 'Куди заправка',
		enableSorting: false,
		cell: (value) => (
			<>
				{value.row.original.filledTank.type} <br />
				{value.row.original.filledTank.name}
			</>
		),
	},
	{
		accessorKey: 'orderedDiesel',
		header: 'Планова кількість дизелю',
	},
	{
		accessorKey: 'filledDiesel',
		header: 'Фактична кількість дизелю',
	},
	{
		accessorKey: 'orderedAdblue',
		header: 'Планова кількість AdBlue',
	},
	{
		accessorKey: 'filledAdblue',
		header: 'Фактична кількість AdBlue',
	},
	{
		accessorKey: 'region',
		header: 'Регіон',
		cell: (value) => value.row.original.region.name,
	},
]

export const refuellingsInfoColumns: ColumnDef<IRefuelling>[] = [
	{
		accessorKey: 'address',
		header: 'Адреса/Координати',
		enableSorting: false,
		minSize: 200,
	},
	{
		accessorKey: 'date',
		header: 'Дата/Час створення',
		enableSorting: false,
		cell: (value) => (
			<>
				{dateFormat(value.row.original.date, 'dd.mm.yyyy')} <br />
				{dateFormat(value.row.original.date, 'HH:MM')}
			</>
		),
	},
	{
		accessorKey: 'refueller',
		header: 'Звідки заправка',
		enableSorting: false,
		cell: (value) => (
			<>
				{value.row.original.refueller.type} <br />
				{value.row.original.refueller.name}
			</>
		),
	},
	{
		accessorKey: 'refuellerTruckerFio',
		header: 'Заправник',
		enableSorting: false,
	},
	{
		accessorKey: 'filledTank',
		header: 'Куди заправка',
		enableSorting: false,
		cell: (value) => (
			<>
				{value.row.original.filledTank.type} <br />
				{value.row.original.filledTank.name}
			</>
		),
	},
	{
		accessorKey: 'filledTruckerFio',
		header: 'Отримувач',
		enableSorting: false,
	},
	{
		accessorKey: 'orderedDiesel',
		header: 'Планова кількість дизелю',
	},
	{
		accessorKey: 'filledDiesel',
		header: 'Фактична кількість дизелю',
	},
	{
		accessorKey: 'orderedAdblue',
		header: 'Планова кількість AdBlue',
	},
	{
		accessorKey: 'filledAdblue',
		header: 'Фактична кількість AdBlue',
	},
]
